import {instance, onErrorFunction} from "../../config/axios-cnf";


export const apiGetReaders = (id, callback, error) => {
    instance.get("/api/v2/reader", {params:{id}})
        .then(response => callback(response.data))
        .catch(err => error(onErrorFunction(err)))
}
